import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=781cf7fe&"
import script from "./ThirdSection.vue?vue&type=script&lang=ts&"
export * from "./ThirdSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports